import { ClockIcon } from '@components/Icons/ClockIcon';
import { USBIcon } from '@components/Icons/USBIcon';
import { VideoSelectedIcon } from '@components/Icons/VideoSelectedIcon';
import { ImageOutlined } from '@mui/icons-material';
import { ReactNode } from 'react';
import css from './SummaryBlock.module.scss';

export type SummaryBlockVariant = 'n-selected' | 'images' | 'duration' | 'size' | 'awesomeness';

interface SummaryBlockProps {
  variant: SummaryBlockVariant;
  value: string | number;
  className?: string;
}

export const SummaryBlock = ({ variant, value, className }: SummaryBlockProps) => {
  const getIcon = (): ReactNode => {
    switch (variant) {
      case 'n-selected':
        return <VideoSelectedIcon />;
      case 'images':
        return <ImageOutlined />;
      case 'duration':
        return <ClockIcon />;
      case 'size':
        return <USBIcon />;
      case 'awesomeness':
        return null;
      default:
        return null;
    }
  };

  const getLabel = (): string => {
    switch (variant) {
      case 'n-selected':
        return 'media selected';
      case 'images':
        return value === 1 ? 'image' : 'images';
      case 'duration':
        return 'total duration';
      case 'size':
        return 'total size';
      case 'awesomeness':
        return 'awesome';
      default:
        return '';
    }
  };

  return (
    <div className={css.summaryBlock}>
      <div className={css.summaryBlockNumber}>
        {getIcon()} {value}
      </div>
      <div className={css.summaryBlockText}>{getLabel()}</div>
    </div>
  );
};
